<div class="top-icon">
  <div class="icon-screen_rotation"></div>
</div>
<div class="message-text">
  <h3>{{ 'notSupportedViewport.title' | translate }}</h3>
  <p>{{ 'notSupportedViewport.message' | translate }}</p>
</div>
<div class="btn-block">
  <button (click)="close()">{{ 'common.gotIt' | translate }}</button>
</div>

